var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "348px",
    height: "348px",
    viewBox: "0 0 348 348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ACFDD898-0158-47D3-866B-40E614037458") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ai-chat-2-copy-4",
    transform: "translate(-468.000000, -2342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(468.000000, 2342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mic-line",
    transform: "translate(95.000000, 78.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5004888,17.4545455 C64.7746375,17.4545455 52.8373571,29.1765818 52.8373571,43.6363636 L52.8373571,78.5454545 C52.8373571,93.0056727 64.7746375,104.727273 79.5004888,104.727273 C94.2254514,104.727273 106.163265,93.0056727 106.163265,78.5454545 L106.163265,43.6363636 C106.163265,29.1765818 94.2254514,17.4545455 79.5004888,17.4545455 Z M79.5004888,0 C104.042686,0 123.938449,19.5366982 123.938449,43.6363636 L123.938449,78.5454545 C123.938449,102.644945 104.042686,122.181818 79.5004888,122.181818 C54.9576699,122.181818 35.0621729,102.644945 35.0621729,78.5454545 L35.0621729,43.6363636 C35.0621729,19.5366982 54.9576699,0 79.5004888,0 Z M0,87.2727273 L17.9170301,87.2727273 C22.2295564,116.878255 48.1583065,139.636364 79.5004888,139.636364 C110.841694,139.636364 136.770355,116.878255 141.083503,87.2727273 L159,87.2727273 C154.901931,123.679418 125.46356,152.586764 88.3880809,156.611782 L88.3880809,192 L70.6128967,192 L70.6128967,156.611782 C33.5368843,152.586764 4.09851309,123.679418 0,87.2727273 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    cx: 174,
    cy: 174,
    r: 173
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopMic);
export default __webpack_public_path__ + "static/media/stop-mic.93635baca6534d671e82da8d6f95f5eb.svg";
export { ForwardRef as ReactComponent };